import React from 'react';

import BottomSheetModal from 'Components/BottomSheetModal';
import { useLogout } from 'Hooks/useLogout';

interface LogOutModalProps {
  onClose: () => void;
  open: boolean;
}

const LogOutModal: React.FC<LogOutModalProps> = ({ onClose, open }) => {
  const { closeSession } = useLogout();

  return (
    <BottomSheetModal
      acceptButtonProps={{
        label: 'Sí, cerrar',
        onClick: () => closeSession(),
      }}
      cancelButtonProps={{ label: 'No, continuar', onClick: onClose }}
      onClose={onClose}
      open={open}
      title="¿Seguro que deseas cerrar sesión?"
    />
  );
};

export default LogOutModal;
